export const PAYPAL_CART_KEY = '__paypal_hosted_cart__';

export const isLocalStorageEnabled = () => {
  const testKey = '__test__localStorage__';
  try {
    if (window.localStorage) {
      const value = Math.random().toString(); // NOSONAR this random number not need to be secure
      window.localStorage.setItem(testKey, value);
      const result = window.localStorage.getItem(testKey);
      window.localStorage.removeItem(testKey);
      if (value === result) {
        return true;
      }
    }
  } catch (err) {
    // err
  }
  return false;
};

export const setItem = (key: string, item: string) => {
  const storage = window.localStorage;
  if (!storage || !key || !item) {
    return;
  }
  try {
    storage.setItem(key, item);
  } catch (e) {
    console.error(e);
  }
};

export const getItem = (key: string): string | null => {
  const storage = window.localStorage;
  try {
    let value: string | null;
    if (storage) {
      value = storage.getItem(key);
      return value;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

export const getSessionId = () => {
  let sessionId: string | undefined;

  try {
    const paypal_storage = getItem('__paypal_storage__') ?? '';
    sessionId = JSON.parse(paypal_storage)?.__session__?.guid;
  } catch (e) {
    console.error(e);
  }

  return sessionId;
};
